export default "__VITE_ASSET__97127482__"